/**
 * @property {string} value
 */
export default class Operator {
    constructor() {
        this.value = Operator.and;
    }

    /**
     * @return {string}
     */
    static get and() {
        return "and";
    }

    valueOf() {
        return this.value;
    }

    /**
     * @return {string}
     */
    static get or() {
        return "or";
    }
}
